import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 20,
  small: 14,
  xSmall: 10
};
const MinusIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M5 19.5H35V20.5H5V19.5Z", fill: "white" }),
          /* @__PURE__ */ React.createElement("path", { d: "M5 19.5H35V20.5H5V19.5Z", fill: "currentColor" })
        );
      case "xSmall":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 16 16",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.5H13V8.5H3V7.5Z", fill: "white" }),
          /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.5H13V8.5H3V7.5Z", fill: "currentColor" })
        );
      case "small":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 9.5H17V10.5H3V9.5Z", fill: "white" }),
          /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 9.5H17V10.5H3V9.5Z", fill: "currentColor" })
        );
      case "medium":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M5 14.5H25V15.5H5V14.5Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement("path", { d: "M5 14.5H25V15.5H5V14.5Z", fill: "currentColor" })
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
MinusIcon.iconName = "MinusIcon";

export { MinusIcon };
